<template>
  <div class="main-content">

    <EmptyCardModal
      v-if="modalExportData"
      ref="exportXlsModal"
      :modalData="modalExportData"
      :onModalClose="() => modalExportData = null"
      :onModalAccept="() => exportXLS(true)"
    >
      <slot>
        <div>
          <ExcelExportOptions ref="exportExcelOptions"
                              :extraOptions="{
              groupPrices: true,
              invoiceNum: true,
              incomeByFact: true
            }"
          />
        </div>
      </slot>
    </EmptyCardModal>

    <div>
      <div class="card">
        <div class="card-body">
          <div class="text-right">
            <LoadingButton
              title="экспортировать в XLS"
              :loading="btnLoading"
              type="button"
              :color="$constants.PRIMARY_COLOR"
              :onClick="() => exportXLS()"
              className="btn btn-outline-info"
            />
            <button @click="getRecords(1)" class="btn btn-outline-info btn-sm">Обновить</button>
          </div>
          <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center mt-3"/>
          <template v-if="!loading">
            <div>
              <table class="table table-hover table-sm mt-1">
                <thead>
                <tr>
                  <th></th>
                  <th></th>
                  <th>ID</th>
                  <th>Поставщик</th>
                  <th>Препараты</th>
                  <th>Скидка</th>
                  <th>Расходы</th>
                  <th>Всего</th>
                  <th>Комментарий</th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(record, i) in records" :key="record.id" :class="{mark: selectedOrders[record.id]}">
                  <td><input type="checkbox" v-model="selectedOrders[record.id]"></td>
                  <td>{{ (i + 1) + ((paginator.current_page - 1) * paginator.per_page) }}</td>
                  <td>{{ record.id }}</td>
                  <td>{{ record.supplier_title }}</td>
                  <td><strong>{{ record.details.length }}</strong> на сумму
                    {{ $AllCurrencies[record.currency_id].currency }}
                    <strong>{{ record.totalDrugsSum.toLocaleString('ru-RU') }}</strong></td>
                  <td>{{ record.discount ? record.discount + (+record.discount_type === 1 ? '%' : '') : null }}</td>
                  <td><span class="mr-2">{{ record.extra_settings?.expenses_by_price }}</span>
                    <span class="mr-2">{{ record.extra_settings?.expenses_by_qty }}</span></td>
                  <td>{{
                      $AllCurrencies[record.currency_id].currency
                    }} <strong>{{ record.totalDrugsSumDiscounted.toLocaleString('ru-RU') }}</strong></td>
                  <td>{{ record.comment }}</td>
                  <td>
                    <button @click="showInvoice(record.id)" class="btn btn-xs btn-info newWindowBtn">
                      <i class="icon-fa icon-fa-eye"></i>
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="text-right">
              <paginate v-if="paginator"
                        v-model="paginator.current_page"
                        :page-count="paginator.last_page"
                        ref="Pagination"
                        :page-range="11"
                        :margin-pages="2"
                        :click-handler="getRecords"
                        :prev-text="'&laquo'"
                        :next-text="'&raquo'"
                        :container-class="'pagination'"
                        :prev-class="'page-item'"
                        :prev-link-class="'page-link'"
                        :page-class="'page-item'"
                        :page-link-class="'page-link'"
                        :next-class="'page-item'"
                        :next-link-class="'page-link'"
                        :active-class="'active green_btn'">
              </paginate>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import Paginate from 'vuejs-paginate'
import EmptyCardModal from "@/components/modals/EmptyCardModal";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import ExcelExportOptions from "@/views/admin/invoices/components/ExcelExportOptions.vue";

export default {
  components: {
    ExcelExportOptions,
    Paginate,
    EmptyCardModal,
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      btnLoading: false,
      records: null,
      paginator: null,
      modalExportData: null,
      selectedOrders: {},
    }
  },
  computed: {
    $AllCountries() {
      return this.$store.getters['platform/countries'];
    },
    $AllCurrencies() {
      return this.$store.getters["platform/currencies"];
    }
  },
  created() {
    this.getRecords()
    this.countries = this.$AllCountries.reduce((acc, c) => {
      acc[c.id] = c;
      return acc;
    }, {})
  },
  methods: {
    async exportXLS(confirmed = false) {
      const selectedOrders = Object.keys(this.selectedOrders).filter((k) => this.selectedOrders[k]);
      if (!selectedOrders.length) {
        toastr['warning']('Не выбраны закупки');
        return;
      }
      if (!confirmed) {
        this.modalExportData = {
          header: 'Настройки экспорта в XLS',
          acceptBtnText: 'Выгрузить',
        };
        return;
      }
      this.$refs.exportXlsModal.acceptBtnLoading = true;
      const {data} = await api.post('/excel/exportGroupedOrderInvoice', {
        selectedInvoices: selectedOrders,
        exportExcelOptions: this.$refs.exportExcelOptions.exportOptions
      })
      if (data.success) {
        window.location.href = data.link;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.$refs.exportXlsModal.acceptBtnLoading = false;
    },
    showInvoice(id) {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {type: 'editOrderInvoice', invoiceId: id},
        callBackAction: () => this.getRecords(this.paginator?.current_page || 1)
      });

      // this.$store.dispatch('invoices/setInvoiceToEdit', {invoiceId: id});
    },
    async getRecords(page = 1) {
      this.loading = true;
      this.modalData = null;
      let {data: r_data} = await api.index('/new/suppliers/orders?page=' + page)
      if (r_data.success) {
        const {data, ...pagination} = r_data.records
        this.paginator = pagination
        this.records = data.reduce((acc, r) => {
          r.totalDrugsSum = r.details.reduce((acc, d) => acc + (d.qty * d.income_price), 0);
          r.totalDrugsSumDiscounted = r.details.reduce((acc, d) => acc + (d.qty * (d.price || d.income_price)), 0);
          acc.push(r);
          return acc;
        }, []);
      } else {
        toastr['warning'](r_data.message || 'Ошибка');
      }
      this.loading = false;
    }
  }
}

</script>
